import React from "react";
import { useTranslation } from "react-i18next";
import { GatsbyImage } from "gatsby-plugin-image";
const PersonalizeYourInvestmentPortfolio = (props) => {
  const { t } = useTranslation();

  return (
    <>
      {props.content.edges && (
        <div
          id="personalize-your-investment-portfolio-global"
          className="home d-none d-lg-block"
        >
          <div className="container grid-container my-5 py-5">
            <div className="grid-col-12 text-center mb-5 pb-4">
              <h2
                className="mb-4"
                data-sal="slide-up"
                data-sal-duration="250"
                data-sal-easing="ease-in-quad"
              >
                {t("home.personalize.title")}
              </h2>
              <p
                data-sal="slide-up"
                data-sal-duration="250"
                data-sal-easing="ease-in-quad"
                data-delay="100"
              >
                {t("home.personalize.description")}
              </p>
            </div>
            <div className="grid-col-7 tab-content" id="v-pills-tabContent">
              {props.content.edges.map((post, i) => (
                <div
                  key={`${post.node.acfPartials.pElementId}-${i}`}
                  className={
                    i === 0
                      ? `tab-${post.node.acfPartials.pElementId} tab-pane fade show active`
                      : `tab-${post.node.acfPartials.pElementId} tab-pane fade`
                  }
                  id={post.node.acfPartials.pElementId}
                  role="tabpanel"
                  aria-labelledby={`${post.node.acfPartials.pElementId}-tab`}
                >
                  <GatsbyImage
                    className="img-fluid img-pill"
                    image={
                      post.node.acfPartials.pIcon.localFile.childImageSharp
                        .gatsbyImageData
                    }
                    alt=""
                  />
                </div>
              ))}
            </div>
            <div
              className="grid-col-5 nav flex-column nav-pills"
              id="tab-list"
              role="tablist"
              aria-orientation="vertical"
            >
              {props.content.edges.map((post, i) => (
                <a
                  key={`${post.node.acfPartials.pElementId}-${i}`}
                  className={
                    i === 0
                      ? `tab-${post.node.acfPartials.pElementId} nav-link p-4 my-lg-3 mb-2 mt-5 active`
                      : `tab-${post.node.acfPartials.pElementId} nav-link p-4 my-lg-3 mb-2 mt-5`
                  }
                  id={`${post.node.acfPartials.pElementId}-tab`}
                  data-toggle="pill"
                  href={`#${post.node.acfPartials.pElementId}`}
                  role="tab"
                  aria-controls={`${post.node.acfPartials.pElementId}`}
                  aria-selected={i === 0 ? `true` : `false`}
                >
                  <h5
                    dangerouslySetInnerHTML={{
                      __html: post.node.acfPartials.pHeading,
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: post.node.acfPartials.pContent,
                    }}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PersonalizeYourInvestmentPortfolio;
